import GetAllResourceEntriesInteractor from "../../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../../common/Constants";

import { IAttachmentType } from "../../../attachmentType/model/AttachmentType";
import AttachmentTypeMapper from "../../../attachmentType/service/AttachmentTypeMapper";
import AttachmentTypeParamMapper from "../../../attachmentType/service/AttachmentTypeParamMapper";

export default class GetAllCaseLawDocumentAttachmentTypesInteractor {
  private resource: GetAllResourceEntriesInteractor<IAttachmentType>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(caseLawDocumentId: number) {
    return this.resource.execute(
      `${Constants.caseLawDocumentPath}/${caseLawDocumentId}/${Constants.attachmentTypePath}`,
      AttachmentTypeMapper,
      AttachmentTypeParamMapper
    );
  }
}
